// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"poweroff"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 5.125C4.87867 6.67053 3.5 9.17406 3.5 11.9996C3.5 16.694 7.30558 20.4996 12 20.4996C16.6944 20.4996 20.5 16.694 20.5 11.9996C20.5 9.17406 19.1213 6.67053 17 5.125","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 3V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PoweroffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'poweroff',
    ref,
    icon: element,
  },
));

PoweroffIcon.displayName = 'PoweroffIcon';

export default PoweroffIcon;
